import React, { useState, useEffect } from "react";
import config from "../config";
import { useToast } from "../components/Toast/ToastContext";
import { buttonClass } from "../components/ui/Button";
import { Field } from "../components/ui/Field";
import { Alert } from "../components/ui/Alert";
import Reveal from "../components/ui/Reveal";

const PasswordReset = () => {
  const toast = useToast();
  const [email, setEmail] = useState("");
  const [resetCode, setResetCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);

  const getQueryParams = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const emailParam = searchParams.get("email");
    const resetCodeParam = searchParams.get("resetCode");
    return { email: emailParam, resetCode: resetCodeParam };
  };

  useEffect(() => {
    const { email, resetCode } = getQueryParams();
    if (email && resetCode) {
      setEmail(email);
      setResetCode(resetCode);
    }
  }, []);

  const handleResetRequest = async (e) => {
    e.preventDefault();

    const user = { email };

    try {
      const response = await fetch(`${config.API_ENDPOINT}/login/reset-request`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(user),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error);
      }

      toast.success("Request received, please check your email.");
    } catch (error) {
      setError(error.message);
    }
  };

  const handlePasswordReset = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      toast.warning("Passwords do not match.");
      return;
    }

    if (email.length < 3) {
      toast.warning("Enter your email too.");
      return;
    }

    const resetData = {
      email: email,
      resettoken: resetCode,
      newpass: newPassword,
    };

    try {
      const response = await fetch(`${config.API_ENDPOINT}/login/reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(resetData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error);
      }

      toast.success("Password reset successful.");
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center mt-10 bg-[#191919] p-6">
      <form
        onSubmit={handleResetRequest}
        className="w-full max-w-md mb-6 bg-[#2a2a2a] text-white p-6 rounded-lg shadow-lg border-2 border-black"
        style={{ fontFamily: "RobotoMono, sans-serif" }}
      >
        <h3 className="text-center text-lg font-bold mb-6">Step 1. Request a Reset</h3>
        <Reveal show={!!error}>
          <Alert className="mb-4">{error}</Alert>
        </Reveal>
        <div className="mb-4">
          <label
            htmlFor="useremail"
            className="block mb-2 text-sm font-medium text-on-surface-variant"
          >
            Email:
          </label>
          <Field
            size="lg"
            type="email"
            id="useremail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <button
          type="submit"
          className={`${buttonClass("filled", "lg")} w-full`}
        >
          Request Reset Email
        </button>
      </form>

      <form
        onSubmit={handlePasswordReset}
        className="w-full max-w-md bg-[#2a2a2a] text-white p-6 rounded-lg shadow-lg border-2 border-black"
        style={{ fontFamily: "RobotoMono, sans-serif" }}
      >
        <h3 className="text-center text-lg font-bold mb-6">Step 2. Password Reset</h3>
        <div className="mb-4">
          <label
            htmlFor="resetCode"
            className="block mb-2 text-sm font-medium text-on-surface-variant"
          >
            Reset Code:
          </label>
          <Field
            size="lg"
            type="text"
            id="resetCode"
            value={resetCode}
            onChange={(e) => setResetCode(e.target.value)}
            required
          />
        </div>
        <div className="mb-4">
          <label
            htmlFor="newPassword"
            className="block mb-2 text-sm font-medium text-on-surface-variant"
          >
            New Password:
          </label>
          <Field
            size="lg"
            type="password"
            id="newPassword"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
        </div>
        <div className="mb-4">
          <label
            htmlFor="confirmPassword"
            className="block mb-2 text-sm font-medium text-on-surface-variant"
          >
            Confirm Password:
          </label>
          <Field
            size="lg"
            type="password"
            id="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>
        <button
          type="submit"
          className={`${buttonClass("filled", "lg")} w-full`}
        >
          Reset Password
        </button>
      </form>
    </div>
  );
};

export default PasswordReset;
